export type EncodingId = 'p50k_base' | 'cl100k_base' | 'o200k_base';

export interface ModelPrice {
  modelLabel: string;
  era: string;
  usdPerMillion: number;
  status: 'historical' | 'current';
}

export const pricing: Record<EncodingId, ModelPrice> = {
  p50k_base:  { modelLabel: 'text-davinci-003', era: '~2020',  usdPerMillion: 20,   status: 'historical' },
  cl100k_base:{ modelLabel: 'GPT-4 (8K)',       era: '~2023',  usdPerMillion: 30,   status: 'historical' },
  o200k_base: { modelLabel: 'GPT-5',            era: '2024–',  usdPerMillion: 1.25, status: 'current'    }
};

export const fxNokPerUsd = 10.5;
export const fxDate = 'mai 2026';

export interface Tier {
  name: 'GPT-5' | 'GPT-5.4' | 'GPT-5-nano';
  usdPerMillion: number;
}

export const tiers: readonly [Tier, Tier, Tier] = [
  { name: 'GPT-5',      usdPerMillion: 1.25 },
  { name: 'GPT-5.4',    usdPerMillion: 2.5  },
  { name: 'GPT-5-nano', usdPerMillion: 0.1  }
];

/** Cost of one tokenization call, in Norwegian øre. */
export function oerePerCall(tokens: number, usdPerMillion: number): number {
  const usd = tokens * (usdPerMillion / 1_000_000);
  return usd * fxNokPerUsd * 100;
}

/** Annual cost in NOK for a user/usage profile. */
export function annualKr(
  tokensPerCall: number,
  users: number,
  callsPerUserPerDay: number,
  daysPerYear: number,
  usdPerMillion: number
): number {
  const calls = users * callsPerUserPerDay * daysPerYear;
  const totalTokens = calls * tokensPerCall;
  const usd = totalTokens * (usdPerMillion / 1_000_000);
  return usd * fxNokPerUsd;
}
